import React from 'react'
import { Doughnut } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement,);

interface PieChartProps {
  labels: string[];
  values: number[];
}
interface BarChartProps {
  labels: string[];
  dataValues: number[];
}

export const PieChart: React.FC<PieChartProps> = ({ labels, values }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Dataset",
        data: values,
        backgroundColor: [
          "#5D7E39", // Indigo
          "#92D050", // Green
          "#C0C0C0", // Yellow
          // "#EF4444", // Red
          // "#3B82F6", // Blue
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
    },
  };

  return <Doughnut data={data} options={options}  />;
};




export const BarChart: React.FC<BarChartProps> = ({ labels, dataValues }) => {
  const data = {
    labels,
    datasets: [
      {
        labels:false,
        data: dataValues,
        backgroundColor: "#9adc54",
        borderColor: "#9adc54",
        borderWidth: 1,
        borderRadius: 8,
      },
    ],
  };

  const options: ChartOptions<"bar"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false, 
        labels: {
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          font: { size: 12 },
          stepSize: 5, 
        },
      },
      x: {
        ticks: {
          font: { size: 12 },
        },
        grid: {
        drawTicks: false,
        display: false, // ✅ hide the vertical grid lines on X-axis
      },
      },
    },
  };

  return (
    // <div className="w-full max-w-xl h-full">
    <Bar data={data} options={options} height={300} width={300} />
    // </div>
  );
};




const SampleProfile = () => {
  return (
   <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
              max-w-xl text-2xl lg:text-4xl font-nunito mb-5 
              bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
              px-6 py-2
              before:content-[''] before:absolute before:left-0 before:top-1/2 
              before:-translate-y-1/2 before:-translate-x-full
              before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
              before:border-r-[#92D050]

              after:content-[''] after:absolute after:right-0 after:top-1/2 
              after:-translate-y-1/2 after:translate-x-full
              after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
              after:border-l-[#8CC54F]">Sample Profile</h1>
      <div className="grid grid-cols-3 gap-10">
        <div className="border-2 border-green-400 rounded-xl p-3 shadow-sm text-sm leading-relaxed">
          <ul className="space-y-2">
            <li>• Gender is evenly split</li>
            <li>• Mean age: 45.5</li>
            <li>• Suburban households: 56%</li>
            <li>• 41% have a dog with a pre-existing condition</li>
            <li>• 63% have 1 dog; 37% have 2+</li>
            <li>• 31% follow pet influencers</li>
            <li>• 79% spend-comfortable</li>
          </ul>
        </div>
        <div className="flex flex-col items-center h-full">
          <h2 className="font-bold mb-5">Gender of respondents</h2>
          <PieChart
            labels={["MALE", "FEMALE", "Non-binary/Other"]}
            values={[49.6, 50.1, 0.3]}
          />
        </div>
        <div className="flex flex-col items-center h-full">
          <h2 className="font-bold mb-4">Age distribution of respondents</h2>
          <BarChart
            labels={["Jan", "Feb", "Mar", "Apr", "May"]}
            dataValues={[12, 19, 3, 5, 2]}
          />
          <p className="mt-2 text-sm">Mean age: 45.5</p>
        </div>
      </div>

    </div>
  )
}

export default SampleProfile